/** A real QR code for https://qms.example/t/sample, drawn where a design is previewed
 *  (internal/slip draws the ticket's own on paper). 1 is a dark module. */
const ROWS = [
  '11111110110010011100001111111',
  '10000010110010001111001000001',
  '10111010100100011000101011101',
  '10111010000010001101101011101',
  '10111010110110111111101011101',
  '10000010011100011110001000001',
  '11111110101010101010101111111',
  '00000000001111011001000000000',
  '10011111101111000101110010111',
  '10101101111101001111000110110',
  '10001111011001011100000100100',
  '10011001101011001101111001001',
  '11101110010001011000101100001',
  '00000000111011101000111011111',
  '01110111101111001011110100101',
  '10011000111110010010001010101',
  '00010111101000101000100001000',
  '10100100101101101011100010110',
  '11100111010110010101111011001',
  '11111101010100100011010101100',
  '11000011011001111100111111110',
  '00000000111110100010100011000',
  '11111110101000100101101011000',
  '10000010111100110101100010001',
  '10111010100111100111111111000',
  '10111010110110000111110000010',
  '10111010001000110101010110111',
  '10000010000110001111010111101',
  '11111110110111110101100111000',
]

/** The sample's dark modules as one SVG path, in a square ROWS.length units wide. */
export const SAMPLE_QR_SIZE = ROWS.length
export const SAMPLE_QR_PATH = ROWS.flatMap((row, y) =>
  [...row].flatMap((on, x) => (on === '1' ? [`M${x} ${y}h1v1h-1z`] : [])),
).join('')
